import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import gql from 'graphql-tag';
import { withAccount } from '../../../components/AccountContext';
import UploadForm from './UploadForm';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlErrors } from '../../../utils/NotificationUtil';
import { matchShape, historyShape, growlShape } from '../../../components/prop-types';

const IMPORT_QUERY = gql`mutation ($input: SuperLinkRespondentDefinitionsImportInput!) {
  importFile: importSuperLinkRespondents(input: $input) {
    id
    status
    overwrite
    fileName
    messages
    createdOn
    updatedOn
  }
}
  `;

const UploadFormContainer = (props) => {
  const [importFile] = useMutation(IMPORT_QUERY, {
    refetchQueries: ['superlinkImportList'],
  });
  const onUpload = async (files) => {
    const {
      currentAccount, growl, history,
      match: { params },
    } = props;
    const file = files[0];
    const { superLinkId } = params;
    try {
      const result = await importFile({
        variables: {
          input: {
            accountId: currentAccount,
            superLinkId,
            // for using file drop component, the field name need to be mapped
            // to the input id, in this case, it's always 1
            fieldName: '1',
          },
          file,
        },
      });
      const { id } = result.data.importFile;
      history.push(`/accounts/${currentAccount}/super-links/${superLinkId}/import/${id}`);
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  return (
    <UploadForm
      onUpload={files => onUpload(files)}
    />
  );
};

UploadFormContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
  history: historyShape.isRequired,
  match: matchShape.isRequired,
};

export default withGrowl(
  withRouter(
    injectIntl(
      withAccount(UploadFormContainer),
    ),
  ),
);
